/*
  prodotto-standard-stampa.js — la stampa della foto sulle cornici standard
  (snippets/prodotto-standard-stampa.liquid, 25/09/2026).

  Con «Solo la cornice» non fa niente: il form di Dawn aggiunge la cornice come sempre.
  Con la stampa scelta, intercetta l'invio del form (in cattura, prima di product-form.js):
    1. la foto e' obbligatoria (JPG/PNG, max 20 MB; sotto i 150 ppi solo un avviso);
    2. aggiunge al carrello la variante della stampa col file in «Foto da stampare», il
       nome della cornice e un `_bundle` che la lega alla cornice (multipart su
       /cart/add.js: Shopify salva il file e mette l'URL nella property, come nei
       configuratori);
    3. mette lo stesso `_bundle` sul form della cornice e lo rinvia: product-form.js
       aggiunge la cornice e apre il carrello, che mostra le due righe.
  Aggiorna anche il riepilogo «Stampa» dell'accordion ([data-std-stampa-riepilogo]).

  L'ANTEPRIMA NEI KIT (15/10/2026). Dove lo snippet passa `data-anteprima` (il riquadro del
  foro nella prima immagine, custom.foto_finestra) la foto si carica sempre, anche senza
  stampa, e si vede al posto del foglio: la prima immagine e la foto composte su un canvas,
  la foto a copertura del foro, appoggiato sopra la prima immagine della galleria. Una foto
  dell'altro verso gira la cornice di 90 gradi: e' come si appende. «Togli la foto» rimette
  il foglio. La stampa, dove c'e', usa la stessa foto. Dal 15/10 sera anche nelle scene della
  galleria (a parete, su bianco), quelle col verso della foto, e nelle miniature.

  LA STAMPA COMPRESA (25/10/2026). Con `data-compresa` (i kit di ricorrenza, la stampa nel
  prezzo) non c'e' scelta: la foto e' obbligatoria, e senza l'invio si ferma con l'avviso. Con
  la foto non si aggiunge nessuna riga: il campo file sta nel form (`name`/`form` dallo
  snippet), e product-form.js lo manda con il kit in «Foto da stampare».
*/
(() => {
  const box = document.querySelector('[data-std-stampa]');
  if (!box) return;
  const form = document.getElementById(box.dataset.formId);
  if (!form) return;

  const MAX_BYTE = 20 * 1024 * 1024;
  const PPI_MIN = 150;
  const campoFile = box.querySelector('input[type="file"]');
  const carica = box.querySelector('.std-stampa__carica');
  const avviso = box.querySelector('.std-stampa__avviso');
  const togli = box.querySelector('.std-stampa__togli');
  const finestra = box.dataset.anteprima ? JSON.parse(box.dataset.anteprima) : null;
  const compresa = box.dataset.compresa === '1';
  const conStampa = Boolean(box.dataset.variante) || compresa;
  let scelta = compresa ? 'foto' : '';
  let foto = null;
  let lasciaPassare = false;

  const riepilogo = () => {
    document.querySelectorAll('[data-std-stampa-riepilogo]').forEach((el) => {
      el.textContent = scelta ? `— Stampa fotografica ${box.dataset.formato}` : '— nessuna';
      el.classList.toggle('det-summary__value--nessuno', !scelta);
    });
  };

  const campoBundle = (valore) => {
    let campo = form.querySelector('input[name="properties[_bundle]"]');
    if (!valore) {
      if (campo) campo.remove();
      return;
    }
    if (!campo) {
      campo = document.createElement('input');
      campo.type = 'hidden';
      campo.name = 'properties[_bundle]';
      form.appendChild(campo);
    }
    campo.value = valore;
  };

  box.addEventListener('change', (e) => {
    if (e.target.name !== 'std-stampa-scelta') return;
    scelta = e.target.value;
    carica.hidden = !scelta && !finestra;
    if (!scelta) {
      avviso.textContent = '';
      campoBundle('');
    }
    riepilogo();
  });

  const controllaRisoluzione = (file) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const [a, b] = box.dataset.formato.replace(' cm', '').split('x').map((n) => parseFloat(n.replace(',', '.')));
      const lati = [Math.max(a, b) / 2.54, Math.min(a, b) / 2.54];
      const pixel = [Math.max(img.naturalWidth, img.naturalHeight), Math.min(img.naturalWidth, img.naturalHeight)];
      const ppi = Math.min(pixel[0] / lati[0], pixel[1] / lati[1]);
      avviso.textContent = ppi < PPI_MIN
        ? `La foto è piccola per un ${box.dataset.formato}: stampata si vedrà meno nitida (${Math.round(ppi)} ppi, ne servono almeno ${PPI_MIN}).`
        : 'Foto pronta per la stampa.';
      URL.revokeObjectURL(url);
    };
    img.src = url;
  };

  /* ── l'anteprima nella cornice (kit a un foro) ──
     Ogni immagine della galleria che ha un riquadro (la prima: `finestra`; le scene a parete e
     su bianco: `finestra.scene`, per nome del file) riceve la foto a copertura del foro,
     composta su un canvas e appoggiata sopra; la miniatura cambia con lei. Prima la prima
     immagine, subito, poi le altre una alla volta: la pagina non si ferma. Nella prima, una
     foto dell'altro verso gira la cornice; nelle scene no (una parete non si gira): li' la
     foto va solo nelle immagini col suo verso, le altre restano come sono. */
  const UUID = /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  // il nome del file senza estensione, query e suffisso UUID che Shopify aggiunge a un nome gia' preso
  const chiave = (src) => (src || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '').replace(UUID, '');
  const riquadri = {};
  if (finestra) {
    Object.assign(riquadri, finestra.scene || {});
    riquadri[chiave(box.dataset.immagine)] = { x: finestra.x, y: finestra.y, b: finestra.b, h: finestra.h, principale: true };
  }
  const fatte = [];          // cio' che si rimette com'era con «Togli la foto»
  let giro = 0;              // un caricamento nuovo ferma quello in corso
  const carica1 = (src, cors) => new Promise((ok, ko) => {
    const img = new Image();
    if (cors) img.crossOrigin = 'anonymous';
    img.onload = () => ok(img);
    img.onerror = ko;
    img.src = src;
  });
  const grande = (src) => `${src.split('?')[0]}?width=1600`;
  const togliAnteprima = () => {
    giro += 1;
    fatte.splice(0).forEach((f) => f());
    if (togli) togli.hidden = true;
  };
  const verso = (b, h) => (h > b * 1.05 ? 'v' : b > h * 1.05 ? 'o' : '');
  // l'immagine con la foto nel riquadro; null se la foto ha l'altro verso e girare non si puo'
  const componi = (base, foto, r, puoGirare) => {
    const W = base.naturalWidth, H = base.naturalHeight;
    const vf = verso(foto.naturalWidth, foto.naturalHeight);
    const vr = verso(r.b * W, r.h * H);
    const gira = vf && vr && vf !== vr;
    if (gira && !puoGirare) return null;
    const tela = document.createElement('canvas');
    tela.width = gira ? H : W;
    tela.height = gira ? W : H;
    const ctx = tela.getContext('2d');
    if (gira) {
      ctx.translate(H, 0);
      ctx.rotate(Math.PI / 2);
      ctx.drawImage(base, 0, 0);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      r = { x: 1 - r.y - r.h, y: r.x, b: r.h, h: r.b };
    } else {
      ctx.drawImage(base, 0, 0);
    }
    const [fx, fy, fw, fh] = [r.x * tela.width, r.y * tela.height, r.b * tela.width, r.h * tela.height];
    const k = Math.max(fw / foto.naturalWidth, fh / foto.naturalHeight);
    ctx.save();
    ctx.beginPath(); ctx.rect(fx, fy, fw, fh); ctx.clip();
    ctx.drawImage(foto, fx + (fw - foto.naturalWidth * k) / 2, fy + (fh - foto.naturalHeight * k) / 2,
      foto.naturalWidth * k, foto.naturalHeight * k);
    ctx.restore();
    return { url: tela.toDataURL('image/jpeg', 0.9), gira };
  };
  const appoggia = (slide, url) => {
    const dove = slide.querySelector('.product__media');
    if (!dove) return;
    const sopra = document.createElement('img');
    sopra.className = 'std-anteprima';
    sopra.alt = 'La tua foto nella cornice';
    sopra.src = url;
    dove.appendChild(sopra);
    fatte.push(() => sopra.remove());
    const mini = document.querySelector(`.thumbnail-list__item[data-target="${slide.dataset.mediaId}"] img`);
    if (mini) {
      const [src, srcset] = [mini.getAttribute('src'), mini.getAttribute('srcset')];
      mini.removeAttribute('srcset');
      mini.src = url;
      fatte.push(() => { mini.src = src; if (srcset) mini.setAttribute('srcset', srcset); });
    }
  };
  // la galleria sulla prima immagine: la miniatura (computer) o lo scorrimento (telefono)
  const allaPrima = (slide) => {
    const prima = document.querySelector('.thumbnail-list__item:first-child button.thumbnail');
    if (prima && prima.offsetParent) prima.click();
    const lista = slide.closest('.product__media-list');
    if (lista) lista.scrollLeft = 0;
    slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  const anteprima = async (file) => {
    togliAnteprima();
    const mio = giro;
    const url = URL.createObjectURL(file);
    try {
      const foto = await carica1(url, false);
      const slide = [...document.querySelectorAll('media-gallery .product__media-item')]
        .map((li) => {
          const img = li.querySelector('img');
          const src = img && (img.getAttribute('src') || img.dataset.src);
          return { li, src, r: riquadri[chiave(src)] };
        })
        .filter((x) => x.src && x.r)
        .sort((a, b) => Boolean(b.r.principale) - Boolean(a.r.principale));
      let altroVerso = 0;
      for (const [i, x] of slide.entries()) {
        const base = await carica1(grande(x.src), true);
        if (mio !== giro) return;              // un'altra foto, o «Togli la foto», nel frattempo
        const fatta = componi(base, foto, x.r, Boolean(x.r.principale));
        if (!fatta) { altroVerso += 1; continue; }
        appoggia(x.li, fatta.url);
        if (i === 0) {
          if (togli) togli.hidden = false;
          allaPrima(x.li);
          if (fatta.gira) avviso.textContent = 'La foto ha l\'altro verso: la cornice si appende girata, così la vedi.';
        }
        await new Promise((r) => setTimeout(r, 0));   // il browser respira fra un'immagine e l'altra
      }
    } catch (e) {
      if (mio === giro) avviso.textContent = 'Non riesco a mostrare la foto nella cornice: la puoi caricare lo stesso.';
    } finally {
      URL.revokeObjectURL(url);
    }
  };
  if (togli) togli.addEventListener('click', () => {
    togliAnteprima();
    foto = null;
    campoFile.value = '';
    avviso.textContent = '';
  });

  campoFile.addEventListener('change', () => {
    foto = null;
    avviso.textContent = '';
    const file = campoFile.files[0];
    if (!file) return;
    if (!/^image\/(jpeg|png)$/.test(file.type)) {
      avviso.textContent = 'Serve un file JPG o PNG.';
      campoFile.value = '';
      return;
    }
    if (file.size > MAX_BYTE) {
      avviso.textContent = 'Il file supera i 20 MB: scegline uno più leggero.';
      campoFile.value = '';
      return;
    }
    foto = file;
    if (conStampa) controllaRisoluzione(file);
    if (finestra) anteprima(file);
  });

  document.addEventListener('submit', async (e) => {
    if (e.target !== form || !scelta) return;
    if (lasciaPassare) {
      lasciaPassare = false;
      return;
    }
    if (compresa && foto) return;   // la foto parte col kit: il campo file e' del form
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!foto) {
      avviso.textContent = compresa
        ? 'Carica la tua foto: la stampa è compresa nel kit.'
        : 'Carica la foto da stampare, oppure scegli «Solo la cornice».';
      campoFile.focus();
      return;
    }

    const bundle = `std-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
    // getAttribute, non form.id: il form di Dawn ha un campo name="id" (la variante) e
    // form.id restituisce quel campo: le copie non si trovavano e la stampa entrava x1
    const quantita = document.querySelector(`input[name="quantity"][form="${form.getAttribute('id')}"]`) || form.querySelector('input[name="quantity"]');
    const dati = new FormData();
    dati.append('id', box.dataset.variante);
    dati.append('quantity', String(parseInt(quantita && quantita.value, 10) || 1));
    dati.append('properties[Foto da stampare]', foto);
    dati.append('properties[Per la cornice]', box.dataset.cornice);
    dati.append('properties[_bundle]', bundle);
    dati.append('properties[_stampa_tipo]', 'foto');
    dati.append('properties[_stampa_sku]', box.dataset.sku);

    const pulsante = form.querySelector('[type="submit"]');
    if (pulsante) pulsante.classList.add('loading');
    try {
      const risposta = await fetch('/cart/add.js', {
        method: 'POST',
        body: dati,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      });
      if (!risposta.ok) {
        const errore = await risposta.json().catch(() => ({}));
        throw new Error(errore.description || `errore ${risposta.status}`);
      }
    } catch (err) {
      avviso.textContent = `La stampa non è entrata nel carrello (${err.message}): riprova.`;
      if (pulsante) pulsante.classList.remove('loading');
      return;
    }
    if (pulsante) pulsante.classList.remove('loading');
    campoBundle(bundle);
    lasciaPassare = true;
    form.requestSubmit();
  }, true);
})();
